var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c(
      "div",
      { staticClass: "q-display-1 q-mb-md text-secondary" },
      [
        _c("q-icon", {
          staticClass: "q-mb-sm",
          attrs: { name: "far fa-mailbox" }
        }),
        _vm._v(" " + _vm._s(_vm.$t("mailing_list")) + "\n\t")
      ],
      1
    ),
    _c(
      "div",
      [
        _c("q-table", {
          ref: "table",
          staticClass: "q-mt-md",
          attrs: {
            data: _vm.users,
            columns: _vm.columns,
            "row-key": "id",
            pagination: _vm.server_pagination,
            loading: _vm.loading,
            filter: _vm.filter,
            selection: "multiple",
            "no-data-label": _vm.$t("no_data_avaliable"),
            "no-results-label": _vm.$t("no_results_found"),
            "loading-label": _vm.$t("loading_data"),
            "rows-per-page-label": _vm.$t("items_per_page"),
            "rows-per-page-options": [5, 10, 50, 100],
            "binary-state-sort": "",
            selected: _vm.selected_users
          },
          on: {
            "update:pagination": function($event) {
              _vm.server_pagination = $event
            },
            request: _vm.requestUsers,
            "update:selected": function($event) {
              _vm.selected_users = $event
            }
          },
          scopedSlots: _vm._u([
            {
              key: "top",
              fn: function(props) {
                return [
                  _c("q-search", {
                    attrs: {
                      debounce: 600,
                      icon: "far fa-search",
                      placeholder: _vm.$t("search")
                    },
                    model: {
                      value: _vm.filter,
                      callback: function($$v) {
                        _vm.filter = $$v
                      },
                      expression: "filter"
                    }
                  }),
                  _c("div", { staticClass: "col" }),
                  _vm.reportsPermission
                    ? _c(
                        "q-btn",
                        {
                          staticClass: "q-mr-sm",
                          attrs: {
                            color: "secondary",
                            icon: "fas fa-download",
                            disable: _vm.$buttonDelay(
                              "mailing_report_button_delay"
                            ),
                            label: _vm.$t("mailing_reports")
                          },
                          on: {
                            click: function($event) {
                              return _vm.downloadReport()
                            }
                          }
                        },
                        [
                          _vm.$buttonDelay("mailing_report_button_delay")
                            ? _c(
                                "q-tooltip",
                                {
                                  attrs: {
                                    anchor: "top middle",
                                    self: "bottom middle",
                                    offset: [10, 10]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("report_button_delay")) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "q-btn",
                    {
                      staticClass: "q-mr-sm",
                      attrs: {
                        color: "negative",
                        icon: "far fa-ban",
                        label: _vm.$t("remove_subscriptions"),
                        disable: !_vm.selected_users.length
                      },
                      on: { click: _vm.unsubscribeUsers }
                    },
                    [
                      _c("q-tooltip", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.selected_users.length
                                ? _vm.$t("subscribe_users_tooltip")
                                : _vm.$t("select_users_tooltip")
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  ),
                  _c(
                    "q-btn",
                    {
                      attrs: {
                        color: "secondary",
                        icon: "far fa-plus",
                        label: _vm.$t("subscribe"),
                        disable: !_vm.selected_users.length
                      },
                      on: { click: _vm.subscribeUsers }
                    },
                    [
                      _c("q-tooltip", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.selected_users.length
                                ? _vm.$t("unsubscribe_users_tooltip")
                                : _vm.$t("select_users_tooltip")
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  )
                ]
              }
            },
            {
              key: "header",
              fn: function(props) {
                return _c(
                  "q-tr",
                  { attrs: { props: props } },
                  [
                    _c(
                      "q-th",
                      { attrs: { "auto-width": "" } },
                      [
                        _c("q-checkbox", {
                          attrs: {
                            "indeterminate-value": "some",
                            disable: _vm.loading
                          },
                          model: {
                            value: props.selected,
                            callback: function($$v) {
                              _vm.$set(props, "selected", $$v)
                            },
                            expression: "props.selected"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._l(props.cols, function(col) {
                      return _c(
                        "q-th",
                        { key: col.name, attrs: { props: props } },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t(col.label)) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              }
            },
            {
              key: "body",
              fn: function(props) {
                return _c(
                  "q-tr",
                  {},
                  [
                    _c(
                      "q-td",
                      { attrs: { "auto-width": "" } },
                      [
                        _c("q-checkbox", {
                          attrs: { color: "primary", disable: _vm.loading },
                          model: {
                            value: props.selected,
                            callback: function($$v) {
                              _vm.$set(props, "selected", $$v)
                            },
                            expression: "props.selected"
                          }
                        })
                      ],
                      1
                    ),
                    _c("q-td", { key: "id", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t\t"
                      )
                    ]),
                    _c("q-td", { key: "name", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(props.row.full_name) +
                          "\n\t\t\t\t"
                      )
                    ]),
                    _c("q-td", { key: "email", attrs: { props: props } }, [
                      _vm._v(
                        "\n\t\t\t\t\t" + _vm._s(props.row.email) + "\n\t\t\t\t"
                      )
                    ]),
                    _c(
                      "q-td",
                      {
                        key: "email_unsubscription_date",
                        attrs: { props: props }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(props.row.email_unsubscription_date) +
                            "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _c(
                      "q-td",
                      {
                        key: "email_subscription",
                        attrs: { "auto-width": "", props: props }
                      },
                      [
                        _c("q-btn-toggle", {
                          attrs: {
                            "toggle-color": props.row.email_subscription
                              ? "positive"
                              : "negative",
                            options: _vm.statuses
                          },
                          nativeOn: {
                            click: function($event) {
                              _vm.changeSingleUserSubscription(
                                (_vm.user = props.row)
                              )
                            }
                          },
                          model: {
                            value: props.row.email_subscription,
                            callback: function($$v) {
                              _vm.$set(props.row, "email_subscription", $$v)
                            },
                            expression: "props.row.email_subscription"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }
            }
          ])
        })
      ],
      1
    ),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3 order-last" },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "far fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "admin_overview" })
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }